import {
  TStoreData,
  TStoreFile,
} from "../../../services/api/instances/vectorStoreApi/types";
import { DatabaseState } from "../redux/types";

export const getUpdatedStores = (
  stores: TStoreData[],
  store: TStoreData,
  updates: Partial<TStoreData>
) => {
  const newStore = {
    ...store,
    ...updates,
  };
  const newStores = stores.map((item) => {
    if (item.id === store.id) {
      return newStore;
    }
    return item;
  });
  return { newStore, newStores };
};

export const extractNumber = (str: string): string => {
  return str.match(/\d+$/)![0];
};

export const updateStoreFiles = (
  state: DatabaseState,
  storeId: string,
  tempFileId: string,
  finalFile: TStoreFile
) => {
  const storeIndex = state.dataStore.findIndex((s) => s.id === storeId);
  if (storeIndex === -1) return;

  const store = state.dataStore[storeIndex];
  const updatedFiles = store.files.map((f) =>
    f.id === tempFileId ? finalFile : f
  );

  const updatedStore = { ...store, files: updatedFiles };
  state.dataStore = [
    ...state.dataStore.slice(0, storeIndex),
    updatedStore,
    ...state.dataStore.slice(storeIndex + 1),
  ];

  if (state.selectedStore?.id === storeId) {
    state.selectedStore = updatedStore;
  }
};
